import styled from 'styled-components';

export const ModalContainer = styled.div`
  transform: initial !important;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Modal = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 3px 20px #00000029;
  border-radius: 22px;
  padding: 30px;
  padding-top: 15px;
  z-index: 10;
  min-width: 300px;
`;

export const ModalTitle = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: #010101;
`;

export const ModalClose = styled.span`
  margin-right: 10px;

  svg {
    cursor: pointer;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 50px;
  margin-right: 20px;
`;

export const Image = styled.img`
  object-fit: contain;
  max-width: 50px !important;
  max-height: 50px !important;
  width: auto;
  height: auto;
  margin-right: 0px !important;
`;

export const SeeDetails = styled.p`
  cursor: pointer;
  font-size: 12px;
  color: #828ea0;
  margin: 0;
  font-weight: 500;

  @media (min-width: 1024px) {
    display: block;
  }
`;

export const CertificationInformation = styled.div`
  display: block;

  p {
    margin: 2px;
  }
`;

export const CertificationName = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #010101;
`;

export const CertificationStatus = styled.span`
  text-align: top;
  border: 1px solid #009688;
  border-radius: 21px;
  color: #009688;
  display: inline-block;
  padding: 2px 11px 0px 11px;
  font-weight: 600;
  font-size: 14px;
  margin-left: 5px;
`;

export const CertificationExpires = styled.p`
  font-size: 12px;
  color: #828ea0;
`;

export const CertificationDate = styled.p`
  font-size: 12px;
  color: #010101;
  padding-top: 3px;
`;
